<div class="chip" [ngStyle]="{'background-color': colorHex() | fadeColor:0.2}">
    <i *ngIf="!!icon()" class="chip-icon" [ngStyle]="{'color': colorHex()}">{{ icon() }}</i>
    <span class="chip-label" [ngStyle]="{'color': colorHex()}">
      
      
      {{ label() }}
    <ng-content></ng-content>
    
    </span>
  </div>